<section class="flex flex-col md:flex-row gap-4 bg-white p-6 max-w-4xl mx-auto">
  <section
    class="w-[360px] flex-shrink-0 flex flex-col justify-between border-r border-gray-200 pr-6">
    <app-schedule-appointment-information />
  </section>
  <app-schedule-appointment-calendar />
</section>
<section class="flex flex-col md:flex-row p-6 justify-end">
  <app-schedule-appointment-action />
</section>
